// extracted by mini-css-extract-plugin
module.exports = {"expandWrap":"InfoDropdown_expandWrap__k5567","expandButton":"InfoDropdown_expandButton__wudZY","chevron":"InfoDropdown_chevron__M61on"};